// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__yLVuf","topbar":"Panel_topbar__0OLsE","topbarElement":"Panel_topbarElement__ifFmw","content":"Panel_content__7xsYo","linkContainer":"Panel_linkContainer__bOkuE"};